import "./AutolinkIntegrationCell.scss";

import { createAutolinkRegex } from "@teams/client-shared";
import { IntegrationAutoLinkDTO } from "@teams/types/api";
import React, { ReactNodeArray } from "react";
import reactStringReplace from "react-string-replace";

declare global {
  var markdownit: () => {
    render: (text: string) => string;
  };
}

export const AutolinkIntegrationCell: React.FC<{
  autolinkIntegrations?: IntegrationAutoLinkDTO[];
  text: string;
}> = ({ autolinkIntegrations, text }) => {
  const md = window.markdownit && window.markdownit();
  const renderedText = md ? md.render(text) : text;

  if (!autolinkIntegrations || autolinkIntegrations.length === 0) {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: renderedText,
        }}
      ></div>
    );
  }

  const links: ReactNodeArray = autolinkIntegrations.reduce(
    (out: ReactNodeArray, integration) => {
      const autolinkRegex = createAutolinkRegex(integration.prefix);
      return reactStringReplace(out, autolinkRegex, (match, i) => {
        const outputUrl = integration.url.replace("<num>", match);
        return (
          <a
            key={`${match}_${i}`}
            href={outputUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="autolinkIntegrationCell__autolink"
          >{`${integration.prefix}${match}`}</a>
        );
      });
    },
    [text]
  );

  return <div>{links}</div>;
};
